export const SET_DEVICE = 'SET_DEVICE'
export const SET_GEO_POSITION = 'SET_GEO_POSITION'
export const SET_RESERVATION_DATE = 'SET_RESERVATION_DATE'
export const SET_RESERVATION_DATE_FOR_SERVER = 'SET_RESERVATION_DATE_FOR_SERVER'
export const SHOW_LOADER = 'SHOW_LOADER'


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/global/mutation-types.js
// module id = null
// module chunks = 